// ── 흐름 대시보드 프론트 상수 ────────────────────────────────────────────────

// 차트 색상 — 강조선(수입/지출/순)은 라이트·다크 양쪽에서 잘 보이는 톤으로 고정.
// 축·그리드·텍스트·배경은 전역 CSS 토큰(var(--text-sub) 등)을 직접 SVG 에 사용해 자동 테마 적용.
export const COLORS = {
  inflow:    '#3b82f6', // 파랑 — 라이트/다크 모두 가독성 OK
  outflow:   '#ef4444', // 빨강 — 동일
  net:       'var(--text-sub)', // 회색 점선 — 토큰
  positive:  '#16a34a', // 순흐름 양수 표기
  negative:  '#dc2626', // 순흐름 음수 표기
};

export function fmtAmount(n) {
  const v = Number(n || 0);
  return new Intl.NumberFormat('ko-KR').format(Math.round(v));
}

export function monthLabel(year, month) {
  return `${year}년 ${month}월`;
}

export function todayKstYmd() {
  const now = new Date();
  const kst = new Date(now.getTime() + (now.getTimezoneOffset() + 540) * 60 * 1000);
  const y = kst.getUTCFullYear();
  const m = String(kst.getUTCMonth() + 1).padStart(2, '0');
  const d = String(kst.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
